import { create } from "zustand";

interface ErrorState {
  statusCode: number | null;
  title: string | null;
  description: string | null;
  errorPayload: any;
  showErrorPage: boolean;
  setError: (
    statusCode: number,
    title?: string,
    description?: string,
    errorPayload?: any,
  ) => void;
  clearError: () => void;
  lastFailedRequest: (() => void) | null;
  setLastFailedRequest: (request: (() => void) | null) => void;
}

export const useGlobalError = create<ErrorState>((set) => ({
  statusCode: null,
  title: null,
  description: null,
  errorPayload: null,
  showErrorPage: false,
  lastFailedRequest: null,
  setError: (statusCode, title, description, errorPayload) =>
    set({
      statusCode,
      title: title || null,
      description: description || null,
      errorPayload: errorPayload || null,
      showErrorPage: true,
    }),
  clearError: () =>
    set({
      statusCode: null,
      title: null,
      description: null,
      errorPayload: null,
      showErrorPage: false,
    }),
  setLastFailedRequest: (request) =>
    set({
      lastFailedRequest: request,
    }),
}));
